'use client'
import {
  context_default
} from "./chunk-5YBTZVAT.mjs";

// src/UiProvider/provider.tsx
import { DirectionProvider } from "@radix-ui/react-direction";
import { useRouter } from "@wbk/config";
import { jsx } from "react/jsx-runtime";
var UiProvider = ({ imgFallbacks, children }) => {
  const { locale } = useRouter();
  const dir = (locale == null ? void 0 : locale.startsWith("ar")) ? "rtl" : "ltr";
  return /* @__PURE__ */ jsx(context_default.Provider, { value: { imgFallbacks, dir }, children: /* @__PURE__ */ jsx(DirectionProvider, { dir, children }) });
};
var provider_default = UiProvider;

export {
  provider_default
};
//# sourceMappingURL=chunk-GQJJZX7U.mjs.map